
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[id]/comparison/[slug]",
      function () {
        return require("private-next-pages/category/[id]/comparison/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[id]/comparison/[slug]"])
      });
    }
  